
import { mapState } from "vuex"
import pageMixin from "@/mixins/pageMixin"
import redirectMixin from "@/mixins/redirectMixin"
import GetQuoteHero from "@/components/blocks/GetQuoteHero"
import ContentBlockList from "@soenergy/frontend-library/src/components/ContentBlockList"

export default {
  components: {
    GetQuoteHero,
    ContentBlockList
  },
  storyId: "get-a-quote",
  mixins: [pageMixin, redirectMixin],
  asyncData({ $storyblokHelper }) {
    return $storyblokHelper.get({ id: "get-a-quote" })
  },
  computed: {
    ...mapState({
      isProspectSwitchJourneyEnabled: state =>
        state.contentManagement.isProspectSwitchJourneyEnabled
    })
  }
}
